// Pure utility to compute Top Results preserving current selection logic
// response shape: { artists: [], releases: [], tracks: [], labels: [] }
export const getTopResults = (response, limit = 6) => {
  const results = []
  let artistindex = 0
  let releaseindex = 0
  let trackindex = 0
  let labelindex = 0
  const incrementIndexByType = {
    artists: () => {
      artistindex += 1
    },
    releases: () => {
      releaseindex += 1
    },
    tracks: () => {
      trackindex += 1
    },
    labels: () => {
      labelindex += 1
    }
  }

  while (results.length < limit) {
    let result = {
      item: response?.artists?.[artistindex],
      type: 'artists'
    }

    if (
      !result.item ||
      (response?.releases?.[releaseindex] &&
        result.item._score < response.releases[releaseindex]._score)
    ) {
      result = {
        item: response?.releases?.[releaseindex],
        type: 'releases'
      }
    }
    if (
      !result.item ||
      (response?.tracks?.[trackindex] &&
        result.item._score < response.tracks[trackindex]._score)
    ) {
      result = {
        item: response?.tracks?.[trackindex],
        type: 'tracks'
      }
    }
    if (
      !result.item ||
      (response?.labels?.[labelindex] &&
        result.item._score < response.labels[labelindex]._score)
    ) {
      result = {
        item: response?.labels?.[labelindex],
        type: 'labels'
      }
    }
    if (!result.item) return results

    incrementIndexByType[result.type]?.()

    results.push(result)
  }
  return results
}

export default getTopResults
